<script lang="ts">
import {
  getLocalizedValue,
  getValueWithoutSeparator,
  type LocalizedValueParam,
} from 'composables/localizedValue';

export default {
  methods: {
    getLocalizedValue(value: LocalizedValueParam) {
      return getLocalizedValue(this.$fischer, value);
    },
    getValueWithoutSeparator(value: LocalizedValueParam) {
      return getValueWithoutSeparator(value);
    },
  },
};
</script>
